import { render, staticRenderFns } from "./ApplicationStagesTab.vue?vue&type=template&id=55b91ec4&scoped=true"
import script from "./ApplicationStagesTab.vue?vue&type=script&lang=js"
export * from "./ApplicationStagesTab.vue?vue&type=script&lang=js"
import style0 from "./ApplicationStagesTab.vue?vue&type=style&index=0&id=55b91ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b91ec4",
  null
  
)

export default component.exports